/** @jsx jsx */
import {jsx} from 'theme-ui'
import {theme, useConfig, ComponentsProvider, useCurrentDoc} from 'docz'
import {Styled, ThemeProvider} from 'theme-ui'
import { navigate } from 'gatsby'

import defaultTheme from '~theme'
import components from '~components'
import {LoadingLayout} from "~components/LoadingLayout";
import {Loader} from '~components/Icons'

import {useAuth0} from "@auth0/auth0-react";

const Theme = ({children}) => {
    const config = useConfig()
    const {user, isLoading, isAuthenticated} = useAuth0();
    const docs = useCurrentDoc();

    if(!isLoading && isAuthenticated) {
        const { 'https://www.citnow.com/role' : assignedRoles } = user;
        if(docs.role && assignedRoles.indexOf(docs.role) === -1) {
            navigate('/');
            return null;
        }
    }

    return (
        <ThemeProvider theme={config.themeConfig}>
            <ComponentsProvider components={components}>
                {isLoading ? (
                    <Styled.root><LoadingLayout><Loader /></LoadingLayout></Styled.root>
                ) : (
                    <Styled.root>{children}</Styled.root>
                )}
            </ComponentsProvider>
        </ThemeProvider>
    )
}

export default theme(defaultTheme)(Theme)